import { useHasPermission } from "../../auth/useClaims";

// Branch-wise master (handoff §9.6) - Employees.Create/.Edit are separate
// permissions, same pattern as Customers/Products; no all-branch check
// needed, the API already scopes every request to the caller's own
// branch(es) server-side.
export const useCanCreateEmployees = () => useHasPermission("Employees.Create");
export const useCanEditEmployees = () => useHasPermission("Employees.Edit");

// Promotion (POST /{empId}/promote) has its own dedicated permission, split
// off from Employees.Edit (handoff §9.6) - a role can edit regular employee
// fields without being able to promote, and vice versa.
export const useCanPromoteEmployees = () => useHasPermission("Employees.Promote");

// Salary visibility (the per-employee `hide` flag, handoff §9.6). These two
// are independent (a payroll clerk can hold one without the other) and only
// come into play for an employee with hide:true - for the common hide:false
// case, salary is covered by the normal Employees.View/.Edit, no extra gate.
export const useCanViewSalary = () => useHasPermission("Employees.ViewSalary");
export const useCanEditSalary = () => useHasPermission("Employees.EditSalary");

// Designation Salary Bulk Update (Batch51) - its own dedicated permission,
// separate from EditSalary, since overwriting every active employee's salary
// under a designation in one click is a much bigger blast radius than
// editing one person's own record.
export const useCanBulkUpdateSalary = () => useHasPermission("Employees.BulkUpdateSalary");

// Guard Remarks & Grading (Batch52) - separate from general Employees.View/
// .Edit, same reasoning as ViewSalary/EditSalary: conduct/incident notes are
// more sensitive than the rest of the employee record.
export const useCanViewRemarks = () => useHasPermission("Employees.ViewRemarks");
export const useCanAddRemarks = () => useHasPermission("Employees.AddRemarks");

// Scanned document attachments (Batch68) - Employee Master screen only
// (Flutter never touches this). Same View/Manage split shape as the two
// pairs above.
export const useCanViewDocuments = () => useHasPermission("Employees.ViewDocuments");
export const useCanManageDocuments = () => useHasPermission("Employees.ManageDocuments");
